import { FileSpreadsheet, LayoutTemplate } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { CommandItem } from "@/components/ui/command";
import { reportContents } from "@/lib/report-builder/summary";
import type { CustomReportSummary } from "@/types/reports";

/** One of the caller's custom reports in global search. Same shape as `MarketSearchRow`. */
export function ReportSearchRow({
  report,
  value,
  onSelect,
}: {
  report: CustomReportSummary;
  /** Unique cmdk item value — cmdk keys its keyboard selection off this. */
  value: string;
  onSelect: () => void;
}) {
  const Icon = report.format === "spreadsheet" ? FileSpreadsheet : LayoutTemplate;
  return (
    <CommandItem
      value={value}
      onSelect={onSelect}
      className="group items-start gap-2.5 rounded-none px-3 py-2 data-[selected=true]:bg-primary-dim"
    >
      <Icon
        size={16}
        className="mt-0.5 shrink-0 text-muted-foreground group-data-[selected=true]:text-primary"
      />
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="truncate text-sm text-foreground">{report.name}</span>
        <span className="truncate text-xs text-text-dim">
          {report.description ?? reportContents(report)}
        </span>
      </span>
      <Badge variant="default" className="ml-auto shrink-0 self-start">
        Report
      </Badge>
    </CommandItem>
  );
}
